import { useCapability } from '@/features/permissions/hooks'
import { useEvaluationRubricsRolledOut } from './useEvaluationRubricsRolledOut'
import { useIsSuperUser } from './useIsSuperUser'

export interface RubricAnalysisAccess {
  /** Render the Evaluation Rubric Results panel on a call. */
  visible: boolean
  /**
   * Visible only because the viewer is Careforce staff: the org has not rolled
   * rubrics out, so the panel carries the restricted-access lock.
   */
  staffOnly: boolean
}

/**
 * Who sees the Evaluation Rubric Results panel in the call side sheet and the
 * detail page's Analysis tab.
 *
 * Two boundaries, both required, mirroring `_can_read_rubric_report` in
 * `hoku/server/handlers/data.py` so the panel and the payload agree:
 * `calls.rubricAnalysis` says which roles, and `features.evaluation_rubrics`
 * (the same rollout flag as the Evaluation Rubrics page) whether the org has
 * it at all. Careforce staff see it whatever the flag.
 */
export function useRubricAnalysisAccess(): RubricAnalysisAccess {
  const permitted = useCapability('calls.rubricAnalysis') === true
  const isSuperUser = useIsSuperUser()
  const rolledOut = useEvaluationRubricsRolledOut()

  const visible = permitted && (rolledOut || isSuperUser)
  return { visible, staffOnly: visible && !rolledOut }
}
